<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header"></slot>
          </div>

          <div class="modal-body">
            <slot name="body">default body</slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <!-- <button class="modal-default-button btn btn-success" @click="$emit('close')">Quit</button> -->
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import VBar from "v-bar";
export default {
  components: {
    VBar
  },
  data() {
    return {
      scrollPosition: 0
    };
  },
  methods: {
    handleScroll(e) {
      var currentScrollPosition = e.srcElement.scrollTop;
      if (currentScrollPosition > this.scrollPosition) {
        console.log("Scrolling down");
      }
      this.scrollPosition = currentScrollPosition;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/products/src/product/PictureModalView.vue